<template>
  <div v-if="loading" class="comments">

    <div class="comments__header">

      <div class="comments_filter">
        <div class="filter-item" :class="{ active: filter === 'main' }" @click="filter = 'main'">
          {{ translate('comments.filter.main') }}
        </div>
        <div class="filter-item" :class="{ active: filter === 'my' }" @click="filter = 'my'">
          {{ translate('comments.filter.my') }}
        </div>
        <div class="filter-item" :class="{ active: filter === 'all' }" @click="filter = 'all'">
          {{ translate('comments.filter.all') }}
        </div>
      </div>

      <span
        class="btn-success btn btn-success text-center"
        @click.prevent="add_comment()"
        v-if="permissions.createComments"
      >
        {{ translate('comments.to_add') }}
      </span>
    </div>

    <div
      v-for="(comment, key) in comments"
      class="comment-item"
      :class="{deleted: !comment.visible}"
      :key="key"
    >
      <div class="comment-card">

        <div class="comment-card_header">
          <span class="comment-card_header_name">

            <span
              v-if="comment.visibility_only_owner"
              class="visible mdi mdi-account"
              :title="translate('comments.filter.me')"
            />
            <span
                v-else
                class="visible mdi mdi-account-group"
                :title="translate('comments.filter.god')"
            />

            {{ comment.user_name }}
          </span>

          <div class="right">
            <button
                v-if="permissions.permissionGod"
                type="button"
                class="pin_comment mdi"
                :class="Number(comment.is_pinned) === 1 ? 'mdi-pin active' : 'mdi-pin-outline'"
                :aria-pressed="Number(comment.is_pinned) === 1"
                :aria-label="translate(Number(comment.is_pinned) === 1 ? 'comments.unpin' : 'comments.pin')"
                :title="translate(Number(comment.is_pinned) === 1 ? 'comments.unpin' : 'comments.pin')"
                :disabled="pinning_comment !== null"
                @click="pin_comment(comment)"
            />
            <span class="comment-card_heWader_ts">
            {{ get_date(comment.ts) }}
          </span>

            <span
              v-if="permissions.permissionGod && comment.visible && comment.is_editable === 1"
              class="del_comment mdi mdi-delete"
              :title="translate('comments.del_comment')"
              @click="pre_delete_comment(comment)"
            />
          </div>
        </div>
        <div
            class="comment-card_content"
            :class="comment.priority === 0 ? 'normal' : comment.priority === 1 ? 'medium' : 'high'"
        >
          <div ref="viewerWrap" v-viewer v-html="linkify(comment.text)"></div>
          <span
              v-if="comment.owner && permissions.editComments === true && comment.is_editable === 1"
              @click="edit_comment(comment)"
              class="mdi mdi-pen edit"
          />
        </div>
      </div>

    </div>
  </div>

  <div v-else style="height: 100%" >
    <div class="spinner">
      <scale-loader />
    </div>
  </div>

</template>

<script>

import NewComment from "./Modal/NewComment.vue"
import EditComment from "./Modal/EditComment.vue"
import GlobalConfirm from "components/UIComponents/Confirm/GlobalConfirm.vue";

export default {
  name: 'Comments',
  props: [
    'params',
  ],
  data () {
    return {
      loading: false,
      comments: [],
      pinning_comment: null,
      filter: "main"
    }
  },

  computed:{
    permissions() {
      return this.$store.getters.getPermissions
    }
  },

  watch:{
    filter(){
      clearInterval(this.interval)
      this.req_comments()
    },
    params(){
      clearInterval(this.interval)
      this.req_comments()
    }
  },

  created () {
    this.req_comments()
  },

  methods: {
    pin_comment(comment) {
      if (!this.permissions.permissionGod || this.pinning_comment !== null) return
      this.pinning_comment = comment.id
      this.$http.v1.pinComment(comment.id, {is_pinned: Number(comment.is_pinned) === 1 ? 0 : 1}, () => {
        this.pinning_comment = null
        this.req_comments()
      }, () => {
        this.pinning_comment = null
        this.global_notify('danger', this.translate('comments.pin_error'))
      })
    },
    linkify(raw) {
      let text = String(raw);
      const TP = '\uFFF0IMG', TS = '\uFFF1';
      const imgs = [];
      const IMG_RE = /()\[\[\~\s*([^\]\s]+)\s*\]\]()/g; // \n[[~ url ]]\n

      text = text.replace(IMG_RE, (m, prefix, url) => {
        const safeSrc = `${process.env.VUE_APP_BASE_URL}${String(url).replace(/"/g, '&quot;')}`; // только экранируем кавычки
        const token = `${TP}${imgs.length}${TS}`;
        imgs.push(`${prefix}<img src="${safeSrc}" class="pointer" style="width:100px;padding:2px" alt="" loading="lazy">`);
        return token;
      });

      const urlRegex = /((https?:\/\/|www\.)[^\s<]+)/gi;
      text = text.replace(urlRegex, (url) => {
        const req = url.startsWith('http') ? url.split("://")[1] : url
        const req_section = req.split("/")
        const link = `${req_section[0]}/${req_section[1]}`

        const href = url.startsWith('http') ? url : `https://${url}`;
        return `<a href="${href}" target="_blank" rel="noopener noreferrer">${link}</a>`;
      });

      const emailRegex = /(^|[\s(>])([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(?=$|[\s)<.,!?;:])/g;
      text = text.replace(emailRegex, (match, prefix, email) => {
        return `${prefix}<a href="mailto:${email}">${email}</a>`;
      });

      const TOKEN_RE = new RegExp(`${TP}(\\d+)${TS}`, 'g');
      text = text.replace(TOKEN_RE, (_, i) => imgs[+i] ?? '');

      return text;
    },
    req_comments () {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.get_comments, 100)
    },
    get_comments(){
      let params = {
        ...this.params,
        show_all: this.filter === "all" ? 1 : 0,
        only_my: this.filter === "my" ? 1 : 0,
      }

      this.$http.v1.getComments(params, (response) => {
        this.comments = response.data;
        this.loading = true
      })
    },
    add_comment(){
      let t = this.$createElement(NewComment, {
        props:{
          params: this.params
        },
        on: {
          close: () => { this.$modal.hide('new_comment') },
          update: () => { this.req_comments() }
        }
      })
      let temp = {
        render () { return t }
      }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'new_comment'})
    },
    edit_comment(comment){
      if (this.permissions.editComments === true){
        let t = this.$createElement(EditComment, {
          props:{
            comment
          },
          on: {
            close: () => { this.$modal.hide('edit_comment') },
            update: () => { this.req_comments() }
          }
        })
        let temp = {
          render () { return t }
        }
        this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'edit_comment'})

      }
    },
    pre_delete_comment(comment){
      let t = this.$createElement(GlobalConfirm, {
        props: {
          text: this.translate('comments.del_comment_confirm')
        },
        on: {
          close: () => {
            this.$modal.hide('del_comment')
          },
          confirm: () => {
            this.delete_comment(comment)
            this.$modal.hide('del_comment')
          }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: false, scrollable: true, name: 'del_comment'})

    },
    delete_comment(comment){
      this.$http.v1.deleteComment(comment.id, () => {
        this.global_notify('info', this.translate('comments.del_comment_success'))
        this.req_comments()
      }, () => {
        this.global_notify('danger', this.translate('comments.del_comment_error'))
      })
    }
  },
}

</script>
<style lang='scss' scoped>
.comments{
  &__header{
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: space-around;
    font-size: 18px;
    line-height: 150%;
    .comments_filter{
      display: flex;
      border: 1px solid #eaeaea;
      border-radius: 4px;
      .filter-item{
        cursor: pointer;
        padding: 4px 10px;
        user-select: none;
        transition: background 0.2s;
        font-size: 10px;
        line-height: 150%;

        &:first-child{
          border-radius: 4px 0 0 4px;
        }

        &:last-child{
          border-radius: 0 4px 4px 0;
        }

        &:hover {
          background: #41b88330;
        }

        &.active {
          background: #41b88330;
          color: #252422;
        }
      }
    }
  }
  .comment{
    &-item{
      width: 100%;
      margin: 10px 0;
      &.deleted{
        filter: grayscale(1);
      }
    }
    &-card{
      border-radius: 10px;
      box-shadow: 0 2px 2px #ccc5b980;
      color: #252422;
      position: relative;
      border: 1px solid #ccc;
      background-color: #f8f8f8;
      font: 300 1.3rem/150% "Roboto", Arial, sans-serif;
      &_header{
        //text-transform: uppercase;
        color: #000;
        background: #f4f3ef;
        padding: 10px 6px 10px 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        border-radius: 10px 10px 0 0;
        overflow: hidden;
        &_name{
          display: flex;
          .visible{
            display: block;
            height: 16px;
            width: 16px;
            font-size: 16px;
            color: #333333;
            margin-right: 5px;
          }
        }
        .right{
          margin: 0;
          font-size: 13px;
          .pin_comment{
            border: 0;
            background: transparent;
            color: inherit;
            padding: 0 4px;
            cursor: pointer;
            &.active{
              color: #41B883;
            }
            &:disabled{
              cursor: wait;
            }
          }
          .mdi-delete{
            margin-left: 2px;
            transition: 0.2s;
            &:hover{
              color: #b84141;
            }
          }
        }
      }
      &_content {
        text-align: left;
        padding: 10px 30px 10px 10px;
        border-radius: 0 0 10px 10px;
        overflow: hidden;
        position: relative;
        white-space: pre-line;
        .edit{
          position: absolute;
          width: 20px;
          height: 20px;
          right: 0;
          bottom: calc(50% - 10px);
          cursor: pointer;
          transition: 0.2s;
          &:hover{
            color: #41B883;
          }
        }
        &.normal{
          background-color: #41b88330;
        }
        &.medium{
          background-color: #cfc04f30;
        }
        &.high{
          background-color: #fd3e3e30;
        }
      }
    }
  }
}
</style>
